import { DataCollection } from "@dhx/ts-data";
import { IFileWrapper } from "./types";

export class ReadStackPreview {
	private _data: DataCollection<IFileWrapper>;
	private _readerStack: IFileWrapper[];
	private _isActive: boolean;

	constructor(data: DataCollection<IFileWrapper>) {
		this._readerStack = [];
		this._isActive = false;

		this._data = data;
	}
	add(fileWrapper: IFileWrapper, wait: boolean = false) {
		this._readerStack.push(fileWrapper);
		if (!wait) {
			this.read();
		}
	}
	read() {
		if (!this._readerStack.length || this._isActive) {
			return;
		}

		const fileWrapper = this._readerStack.shift();
		this._isActive = true;

		const reader =  new FileReader();
		reader.readAsDataURL(fileWrapper.file);
		reader.onload = e => {
			const image = new Image();
			image.src = (e.target as any).result;
			image.onload = () => {
				if (this._data.exists(fileWrapper.id)) {
					this._data.update(fileWrapper.id, { image });
				}
				this._isActive = false;

				this.read();
			};
		};
		reader.onerror = () => {
			this._isActive = false;

			this.read();
		};
	}
	stop() {
		this._readerStack = [];
	}
}